const Switcher = (props) => {
  const { label, onChange = () => {}, isRequired, value } = props;
  return (
    <>
      <label className="mmmbaa_label switch">
        {label && label} {isRequired ? <span className="required_star">*</span> : ""}
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => {
            window.e = e;
            onChange(e.target.checked);
          }}
        />
        <span className="slider round"></span>
      </label>
    </>
  );
};

export default Switcher;
